"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getTranslator = getTranslator;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createTranslator = _interopRequireDefault(require("./create-translator"));
var _constants = require("./constants");
var _defaultContext = require("./default-context");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_LOCALE = _constants.ENGLISH_LOCALE;
var baseTranslator = function baseTranslator(key) {
  return key;
};
var DEFAULT_OPTIONS = {
  withRef: false
};
function getTranslator(locale, initialTranslations, context, warn) {
  var translations = context && context.translations || initialTranslations;
  return translations ? (0, _createTranslator["default"])(translations, locale, warn) : baseTranslator;
}
var createConnect = function createConnect(initialTranslations, warn, customContext) {
  return function (TargetComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
    var TranslatorConnect = /*#__PURE__*/function (_Component) {
      (0, _inherits2["default"])(TranslatorConnect, _Component);
      var _super = _createSuper(TranslatorConnect);
      function TranslatorConnect(props) {
        var _this;
        (0, _classCallCheck2["default"])(this, TranslatorConnect);
        _this = _super.call(this, props);
        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2["default"])(_this));
        return _this;
      }
      (0, _createClass2["default"])(TranslatorConnect, [{
        key: "setWrappedInstance",
        value: function setWrappedInstance(ref) {
          this.wrappedInstance = ref;
        }
      }, {
        key: "getWrappedInstance",
        value: function getWrappedInstance() {
          return this.wrappedInstance;
        }
      }, {
        key: "getConnectedProps",
        value: function getConnectedProps(context) {
          var contextLocale = context && context.locale;
          if (process.env.NODE_ENV === _constants.DEVELOPMENT && !contextLocale) {
            console.warn('[js-translations] missing locale in the context. Check your translations Provider.');
          }
          var locale = contextLocale || DEFAULT_LOCALE;
          var translator = getTranslator(locale, initialTranslations, context, warn);
          return options.withRef ? {
            ref: this.setWrappedInstance,
            t: translator
          } : {
            t: translator
          };
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var C = customContext || _defaultContext.DefaultContext;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(C.Consumer, {
            children: function children(context) {
              return /*#__PURE__*/(0, _react.createElement)(TargetComponent, Object.assign({}, _this2.props, _this2.getConnectedProps(context)));
            }
          });
        }
      }]);
      return TranslatorConnect;
    }(_react.Component);
    TranslatorConnect.contextTypes = {
      locale: _propTypes["default"].string,
      translations: _propTypes["default"].object
    };
    return TranslatorConnect;
  };
};
var _default = createConnect;
exports["default"] = _default;